import React, { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import styles from './SizeMatchItemComponent.module.scss';
import boddVariables from '../../../variables.module.scss';
import { SizeMatchRecommendation } from '../../../services/DataFormatService';
import GarmentIcon from '../GarmentIcon/GarmentIcon';

interface SizeMatchItemComponentProps {
    sizeMatchRecommendation: SizeMatchRecommendation;
}

const SizeMatchItemComponent: FC<SizeMatchItemComponentProps> = (props) => {
    const { sizeMatchRecommendation } = props;
    return (
        <div className={styles.SizeMatchItemComponent} data-testid="SizeMatchItemComponent">
            <Stack
                direction="row"
                sx={{
                    p: 2,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    bgcolor: boddVariables.grey10,
                    border: `2px solid ${boddVariables.grey25}`,
                }}
            >
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{ alignItems: 'center' }}
                >
                    <Box
                        sx={{ height: '39px', width: '39px', color: boddVariables.grey600 }}
                    >
                        <GarmentIcon
                            garment={sizeMatchRecommendation.garmentType}
                        />
                    </Box>
                    <Box sx={{ padding: '4px 8px' }}>
                        {sizeMatchRecommendation.gender && (
                            <Box
                                sx={{
                                    padding: '1px 6px',
                                    marginBottom: '8px',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center',
                                    borderRadius: '2px',
                                    maxWidth: 'fit-content',
                                    background: boddVariables.grey600,
                                }}
                            >
                                <Typography
                                    color={boddVariables.white}
                                    sx={{
                                        fontWeight: 500,
                                        fontSize: '14px',
                                        fontStyle: 'normal',
                                    }}
                                >
                                    {sizeMatchRecommendation.gender}
                                </Typography>
                            </Box>
                        )}
                        <Typography
                            sx={{
                                fontWeight: '400',
                                fontSize: '16px',
                                lineHeight: '21px',
                                width: 'auto',
                                textAlign: 'left',
                                color: boddVariables.black,
                            }}
                        >
                            {sizeMatchRecommendation.productName}
                        </Typography>
                    </Box>
                </Stack>
                {sizeMatchRecommendation.recommendation === 'No Match!' ? (
                    <Typography
                        sx={{
                            fontWeight: '600',
                            fontSize: '20px',
                            textAlign: 'right',
                            whiteSpace: 'nowrap',
                            color: boddVariables.grey200,
                        }}
                    >
                        No match
                    </Typography>
                ) : (
                    <Typography
                        sx={{
                            fontWeight: '600',
                            fontSize: '20px',
                            textAlign: 'right',
                            color: boddVariables.brandBlue,
                        }}
                    >
                        {sizeMatchRecommendation.recommendation}
                    </Typography>
                )}
            </Stack>
        </div>
    );
};

export default SizeMatchItemComponent;
